import React from 'react'
import { l } from '@manychat/manyui'

const FBPageConnectionWasLostNotification = () => {
  return <span>{l.translate('The page connection was lost')}</span>
}

export default FBPageConnectionWasLostNotification
